import { Box, Image } from '@mantine/core';
import { ChatConversationTile } from '@/src/shared/components/chat/chat-conversation-tile';
import { useMarketplaceCustomerChatContext } from '../../../_contexts';
import { RegisterSelfMedicationConversationTile } from '../../ui/marketplace/register-self-medication-conversation-tile';

export function ChatFloatingWindowMedicationConversationTile() {
  const {
    selfMedicationConversation,
    setSelectedConversationId,
    selectedConversationId,
    createSelfMedicationConversation,
    isCreatingSelfMedicationConversation,
  } = useMarketplaceCustomerChatContext();

  const selfMedicationConversationIsSelected =
    selectedConversationId === selfMedicationConversation?.props.id;

  if (!selfMedicationConversation) {
    return (
      <Box my="xs">
        <RegisterSelfMedicationConversationTile
          size="sm"
          createSelfMedicationConversation={createSelfMedicationConversation}
          isCreatingSelfMedicationConversation={
            isCreatingSelfMedicationConversation
          }
        />
      </Box>
    );
  }

  return (
    <ChatConversationTile
      size="sm"
      conversation={selfMedicationConversation!}
      overrideName="Chat Swamedikasi"
      isSelected={selfMedicationConversationIsSelected}
      onClick={() =>
        setSelectedConversationId(selfMedicationConversation!.props.id)
      }
      avatar={
        <Image
          w="2rem"
          h="2rem"
          src="/images/pharmacy.jpg"
          alt="Chat Swamedikasi"
          className="object-contain!"
          bg="white"
          bdrs={999}
        />
      }
      showLastMessage={false}
    />
  );
}
